import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@mui/material';
import { useParams } from 'react-router';
import DigitalObjectsList from '../../custom/Details/DigitalObjectsList';
import DigitalPreview from './DigitalPreview';
import useLocales from '../../../hooks/useLocales';
import { dispatch, useSelector } from '../../../redux/store';
import { getDOByKey, clearDO } from '../../../redux/slices/culturalObject';
import './CultureObject.css';
import CustomModal from '../../custom/Modals/CustomModal';
import DigitalDownload from './DigitalDownload';

DigitalObjects.propTypes = {
  objects: PropTypes.array,
  allow: PropTypes.any,
  digitalized: PropTypes.bool,
  download: PropTypes.bool,
  onCloseDownload: PropTypes.func,
};

export default function DigitalObjects({ objects, allow, digitalized, download, onCloseDownload }) {
  const { translate } = useLocales();
  const { id } = useParams();
  const [preview, setPreview] = useState(null);
  const { digitalObjects, currentCO } = useSelector((state) => state.culturalObject);

  useEffect(() => {
    dispatch(clearDO());
    if (currentCO.key === id) {
      if (allow !== 'view_none' && digitalized) {
        objects.forEach((object) => {
          dispatch(getDOByKey(object.id));
        });
      }
    }
  }, [objects, allow, currentCO, id, digitalized]);

  useEffect(() => {
    if (digitalObjects.length > 0) {
      setPreview((old) => (old === null || old === undefined ? digitalObjects[0] : old));
    } else {
      setPreview(null);
    }
  }, [digitalObjects]);
  const handleMediaChange = (idx, object) => {
    setPreview(object);
  };

  return (
    <>
      {!digitalized && (
        <div className="preview-box">
          <span className="not-available">{translate('preview.nodigitalized')}</span>
        </div>
      )}
      {allow === 'view_none' && digitalized && (
        <div className="preview-box">
          <span className="not-available">{translate('preview.license')}</span>
        </div>
      )}
      {allow !== 'view_none' && digitalized && (
        <>
          <DigitalPreview preview={preview} />
          <Grid xs={12} item>
            <DigitalObjectsList objects={digitalObjects} onClick={handleMediaChange} active={preview} />
          </Grid>
          <CustomModal open={download} onClose={onCloseDownload}>
            <div style={{ overflowY: 'auto', maxHeight: '80vh' }}>
              {digitalObjects.length > 0 ? (
                digitalObjects.map((obj, idx) => <DigitalDownload key={idx} object={obj} />)
              ) : (
                <Typography variant="body2">Nie sú dostupné objekty na stiahnutie</Typography>
              )}
            </div>
          </CustomModal>
        </>
      )}
    </>
  );
}
